import React from "react";

export const GuaranteePanel = ({ side, roles, selected, onToggle, maxSlots, pool }) => {
  const accent = side === "attacker" ? "#E67300" : "#1F88E8";
  return (
    <div className="border border-neutral-800 bg-neutral-950/60" data-testid={`guarantee-panel-${side}`}>
      <div className="border-b border-neutral-800 px-4 py-3 flex items-center justify-between">
        <div
          className="text-xs font-bold tracking-[0.3em] uppercase"
          style={{ color: accent, fontFamily: '"JetBrains Mono", monospace' }}
        >
          {side} Guarantees
        </div>
        <div
          className="text-[10px] tracking-widest text-neutral-500"
          style={{ fontFamily: '"JetBrains Mono", monospace' }}
        >
          {selected.size}/{maxSlots}
        </div>
      </div>
      <div className="p-2">
        {roles.map((role) => {
          const poolIds = new Set(pool.map((o) => o.id));
          const availableOps = role.operators.filter((id) => poolIds.has(id));
          const isSelected = selected.has(role.id);
          const disabled = !isSelected && (selected.size >= maxSlots || availableOps.length === 0);
          return (
            <button
              key={role.id}
              data-testid={`guarantee-${side}-${role.id}-btn`}
              onClick={() => onToggle(role.id)}
              disabled={disabled}
              className={`w-full text-left px-3 py-2 flex items-center gap-3 transition-colors ${
                isSelected
                  ? "bg-neutral-900"
                  : "hover:bg-neutral-900 disabled:hover:bg-transparent"
              } disabled:opacity-40 disabled:cursor-not-allowed`}
            >
              <span
                className="inline-flex items-center justify-center w-4 h-4 border shrink-0"
                style={{
                  borderColor: isSelected ? accent : "#404040",
                  backgroundColor: isSelected ? accent : "transparent",
                }}
              >
                {isSelected && (
                  <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                    <path
                      d="M1.5 5L4 7.5L8.5 2.5"
                      stroke="#000"
                      strokeWidth="1.8"
                      strokeLinecap="square"
                    />
                  </svg>
                )}
              </span>
              <div className="flex-1 min-w-0">
                <div
                  className={`text-sm font-bold tracking-tight uppercase leading-tight ${
                    isSelected ? "text-white" : "text-neutral-300"
                  }`}
                  style={{ fontFamily: '"Barlow Condensed", sans-serif' }}
                >
                  {role.label}
                </div>
                <div
                  className="text-[10px] text-neutral-500 tracking-wider leading-tight"
                  style={{ fontFamily: '"JetBrains Mono", monospace' }}
                >
                  {role.description} · {availableOps.length} avail
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default GuaranteePanel;
